import React, {useState, useEffect} from 'react'
import './ArticlePage.css';
import GlobalFooter from '../common/GlobalFooter';
import GlobalHeader from '../common/GlobalHeader';
import { Link, useParams } from 'react-router-dom';

const ArticlePage: React.FC = () => {
    const { id } = useParams<{id: string}>();
    const [article, setArticle] = useState({
        id: "",
        doctype: "",
        eyecatch: "",
        title: "",
        authors: [],
        timestamp: "",
        tags: [],
        html: "",
    })

    useEffect(() => {
        const fetchArticleAsync = async () => {
            const response = await fetch(`/articles/${id}.json`)
            const data = await response.json()
            setArticle(data);
        };
        fetchArticleAsync();
    }, []);

    return (
        <div className="articlepage-root">
            <GlobalHeader />
            <div className="articlepage-container">
                <div className="articlepage-separater"></div>
                <div className="articlepage-timestamp">更新日: {article.timestamp}</div>
                <div className="articlepage-authors">Authors: {article.authors.join(" ")}</div>
                <div className="articlepage-title">{article.title}</div>
                <div className="articlepage-tags" dangerouslySetInnerHTML={{__html: 'Tags: <span class="articlepage-tag">' + article.tags.join('</span><span class="articlepage-tag">') + "</span>"}}></div>
                <div className="articlepage-separater"></div>
                <div className="articlepage-text" dangerouslySetInnerHTML={{__html: article.html}}></div>
            </div>
            <GlobalFooter />
        </div>
    );
}

export default ArticlePage;